import CryptoJS from "crypto-js";
import appConfig from "../../app-config";

const SECRET = appConfig.VUE_APP_CLIENT_SECRET || "gcorp-cx-app-secret";

export const secureStorage = {
    set(key, value) {
        const encrypted = CryptoJS.AES.encrypt(
            JSON.stringify(value),
            SECRET
        ).toString();
        localStorage.setItem(key, encrypted);
    },

    get(key) {
        const encrypted = localStorage.getItem(key);
        if (!encrypted) return null;
        try {
            const bytes = CryptoJS.AES.decrypt(encrypted, SECRET);
            return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        } catch {
            return null; // tampered or invalid
        }
    },

    remove(key) {
        localStorage.removeItem(key);
    },
};